import { useCallback } from 'react';

// useTooltip предоставляет функции для отображения и скрытия подсказок
export const useTooltip = (setTooltip, tableContainerRef, options, formatPriceForMessage) => {
  // Обработчик наведения мыши на элемент
  const handleMouseEnter = useCallback((event, material) => {
    const targetElement = event.currentTarget;
    const rect = targetElement.getBoundingClientRect();

    const tempTooltip = document.createElement("div");
    tempTooltip.style.visibility = "hidden";
    tempTooltip.style.position = "absolute";

    // Проверяем, является ли material аналогом (из analogs) или исходным материалом
    let currentDensity, currentArea, pricePerSquareMeter;

    if (material.details) {
      // Для аналогов данные берутся из material.details
      currentDensity = material.details.density
        ? parseFloat(material.details.density.replace(",", ".")) || 0
        : 0;
      currentArea = material.details.area
        ? parseFloat(material.details.area.replace(",", ".")) || 0
        : 0;
      pricePerSquareMeter = material.analogPricePerSquareMeter || 0;
    } else {
      // Для исходного материала данные берутся из options
      currentDensity = options[material.name]?.DENSITY
        ? parseFloat(String(options[material.name].DENSITY).replace(",", ".")) || 0
        : 0;
      currentArea = options[material.name]?.AREA_SQUARE
        ? parseFloat(String(options[material.name].AREA_SQUARE).replace(",", ".")) || 0
        : options[material.name]?.AREA_OSB
        ? parseFloat(String(options[material.name].AREA_OSB).replace(",", ".")) || 0
        : 0;
      pricePerSquareMeter = currentArea > 0
        ? (parseFloat(material.pricePerOne) || 0) / currentArea
        : 0;
    }
    
    const coveredArea = material.quantity * currentArea;
    
    // Проверяем, есть ли значимые данные для отображения
    const hasValidData = currentDensity > 0 || coveredArea > 0 || pricePerSquareMeter > 0;
    
    // Если все значения нулевые или не определены, не показываем tooltip
    if (!hasValidData) {
      return;
    }
    
    const typeMaterialStr = material.details?.typeMaterial ? `Тип материала: ${material.details.typeMaterial}<br/>` : '';
    tempTooltip.innerHTML = `${typeMaterialStr}Плотность: ${currentDensity} кг/м³<br/>Покрываемая площадь: ${coveredArea.toFixed(2)} м²<br/>Цена за м²: ${pricePerSquareMeter.toFixed(2)} руб.`;
    tempTooltip.style.padding = "5px 10px";
    document.body.appendChild(tempTooltip);
    const tooltipWidth = tempTooltip.offsetWidth;
    const tooltipHeight = tempTooltip.offsetHeight;
    document.body.removeChild(tempTooltip);

    // Позиция в координатах viewport (Tooltip использует position: fixed).
    // Центрируем по горизонтали и ставим над элементом.
    let x = rect.left + rect.width / 2;
    let y = rect.top;

    const windowWidth = window.innerWidth;

    // Не вылезаем за правый/левый край (с учётом translate(-50%) центрирования)
    if (x + tooltipWidth / 2 > windowWidth) {
      x = windowWidth - tooltipWidth / 2 - 10;
    }
    if (x - tooltipWidth / 2 < 0) {
      x = tooltipWidth / 2 + 10;
    }

    // Если тултип не помещается сверху — показываем чуть ниже элемента
    if (y - tooltipHeight < 0) {
      y = rect.bottom + tooltipHeight + 8;
    }

    setTooltip({
      visible: true,
      text: tempTooltip.innerHTML,
      x,
      y,
      targetElement,
    });
  }, [setTooltip, tableContainerRef, options, formatPriceForMessage]);

  // Обработчик ухода мыши с элемента
  const handleMouseLeave = useCallback(() => {
    setTooltip({ visible: false, text: "", x: 0, y: 0, targetElement: null });
  }, [setTooltip]);

  return { handleMouseEnter, handleMouseLeave };
};